import { observable } from "mobx";
import { Type } from "class-transformer";
import DateRangeRequest from "./dateRangeRequest";
import DecimalRangeRequest from "./decimalRangeRequest";
import type { EntityValidationRules } from "services/validationService";
import { startOfEDAZEshop } from "config";
import addDays from "date-fns/addDays";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SearchTransferPaymentsRequest {
  @observable
  counterpartyAccountNumber?: string;

  /**
   * Counterparty bank.
   */
  @observable
  counterpartyBank?: string;

  /**
   * Counterparty name.
   */
  @observable
  counterpartyName?: string;

  /**
   * Variable symbol.
   */
  @observable
  variableSymbol?: number;

  /**
   * Specific symbol.
   */
  @observable
  specificSymbol?: number;

  /**
   * Constant symbol.
   */
  @observable
  constantSymbol?: number;

  /**
   * Bank transaction ID.
   */
  @observable
  bankTransactionId?: string;

  @observable
  @Type(() => DecimalRangeRequest)
  amount?: DecimalRangeRequest;

  @observable
  @Type(() => DateRangeRequest)
  statementDate?: DateRangeRequest;

  /**
   * Message for recipient.
   */
  @observable
  messageForRecipient?: string;

  /**
   * Additional information.
   */
  @observable
  additionalInformation?: string;
}

const oneOfRequiredForRequest = (entity: SearchTransferPaymentsRequest) => {
  return (
    !entity.counterpartyAccountNumber &&
    !entity.counterpartyBank &&
    !entity.counterpartyName &&
    !entity.variableSymbol &&
    !entity.specificSymbol &&
    !entity.constantSymbol &&
    !entity.messageForRecipient &&
    !entity.additionalInformation &&
    !entity.bankTransactionId
  );
};

const customMessage = "oneOfAttributesIsRequired";

export const SearchTransferPaymentsRequestValidationRules: EntityValidationRules<SearchTransferPaymentsRequest> = {
  counterpartyAccountNumber: {
    isLength: {
      max: 35,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  counterpartyBank: {
    isLength: {
      max: 35,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  counterpartyName: {
    isLength: {
      min: 3,
      max: 35,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  variableSymbol: {
    isLength: {
      max: 10,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  specificSymbol: {
    isLength: {
      max: 10,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  constantSymbol: {
    isLength: {
      max: 10,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  messageForRecipient: {
    isLength: {
      min: 3,
      max: 140,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  additionalInformation: {
    isLength: {
      min: 3,
      max: 140,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  bankTransactionId: {
    isLength: {
      max: 13,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  amount: {
    isNumberRange: {
      min: 0,
    },
  },
  statementDate: {
    isDateRange: {
      min: startOfEDAZEshop,
      max: addDays(new Date(), 1),
    },
  },
};
